var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPediatricianIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.9109,
    cy: 12.5553,
    r: 2.16667,
    stroke: "#00E500"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3554,
    cy: 12.5553,
    r: 2.16667,
    stroke: "#00E500"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.1333,
    cy: 13.444,
    r: 10.1667,
    fill: "white",
    stroke: "#00E500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1332 14.333L20.1332 15.2219",
    stroke: "#00E500",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.917 30.3336V17.8891C30.917 16.9073 30.1174 16.1034 29.1387 16.1823C20.7906 16.8551 14.261 22.2699 11.3066 30.5238C9.32131 36.0702 14.3593 41.0002 20.2503 41.0002C26.1414 41.0002 30.917 36.2246 30.917 30.3336Z",
    fill: "#0052FD",
    stroke: "#00E500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46655 29.8639V18.1113C9.46655 17.0068 10.3649 16.102 11.4654 16.1965C19.9972 16.9287 27.1901 22.3431 29.8337 30.9108C31.5352 36.4254 26.374 41.0002 20.6029 41.0002C14.4525 41.0002 9.46655 36.0143 9.46655 29.8639Z",
    fill: "#0052FD",
    stroke: "#00E500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4666 10.7773C25.4666 11.2683 25.0687 11.6662 24.5777 11.6662C24.0868 11.6662 23.6888 11.2683 23.6888 10.7773",
    stroke: "#00E500",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1332 4.55556C19.1513 4.55556 18.3554 3.75962 18.3554 2.77778C18.3554 1.79594 19.1513 1 20.1332 1",
    stroke: "#00E500",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5775 10.7773C16.5775 11.2683 16.1795 11.6662 15.6886 11.6662C15.1977 11.6662 14.7997 11.2683 14.7997 10.7773",
    stroke: "#00E500",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1332 30.333V34.7775M13.911 32.6859H18.3555",
    stroke: "#00E500",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPediatricianIcon);
export default __webpack_public_path__ + "static/media/PediatricianIcon.0d9b654fa17b149006a23fd6ead2d529.svg";
export { ForwardRef as ReactComponent };